import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { userProfilePath } from 'routes/paths';
import useConfig from 'hooks/useConfig';
import { ProfileTabProps } from 'types/layout';
import { IoIosLogOut } from 'react-icons/io';
import { CgProfile } from 'react-icons/cg';
import { MdOutlineHelpOutline } from 'react-icons/md';

const ProfileTab = ({ handleLogout, setOpen }: ProfileTabProps) => {
    const { onChangeShowGuide } = useConfig();
    const navigate = useNavigate();
    const location = useLocation();
    const { pathname } = location;

    return (
        <List component='nav' sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 35 } }}>
            <ListItemButton
                selected={pathname === '/profile'}
                onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                    navigate(userProfilePath(true));
                }}>
                <ListItemIcon>
                    <CgProfile size={20} />
                </ListItemIcon>
                <ListItemText primary='View Profile' />
            </ListItemButton>
            <ListItemButton
                onClick={() => {
                    onChangeShowGuide(true), setOpen(false);
                }}>
                <ListItemIcon>
                    <MdOutlineHelpOutline size={20} />
                </ListItemIcon>
                <ListItemText primary='Show Guide' />
            </ListItemButton>
            <ListItemButton onClick={handleLogout}>
                <ListItemIcon>
                    <IoIosLogOut size={22} />
                </ListItemIcon>
                <ListItemText primary='Logout' />
            </ListItemButton>
        </List>
    );
};

export default ProfileTab;
